import { BoundedContent, Box, ErrorBoundary, SWAN_STYLE_KEY_MAP } from '@vp/swan'

import { useSwanStyleKeys, useIdentity } from '@vp/ubik-context'
import { createAuthorization } from '@vp/email-subscription-component'

import { WithIdentityProvider } from './WithIdentityProvider'
import { EmailComponentWrapper } from './EmailComponentWrapper'

export type EmailSignupBannerProps = object

export const EmailSignupBanner = WithIdentityProvider(() => {
  const { identity } = useIdentity()
  const authorization = identity ? createAuthorization(identity.authorization) : undefined

  useSwanStyleKeys([
    SWAN_STYLE_KEY_MAP.core,
    SWAN_STYLE_KEY_MAP.grid,
    SWAN_STYLE_KEY_MAP.icon,
    SWAN_STYLE_KEY_MAP.button,
    SWAN_STYLE_KEY_MAP.carousel,
    SWAN_STYLE_KEY_MAP.standardTile,
    SWAN_STYLE_KEY_MAP.popover,
    SWAN_STYLE_KEY_MAP.hidden,
    SWAN_STYLE_KEY_MAP.visible,
    SWAN_STYLE_KEY_MAP.utility,
    SWAN_STYLE_KEY_MAP.banner,
  ])

  return (
    <Box id="email">
      {authorization && (
        <ErrorBoundary>
          <BoundedContent px={0}>
            <section>
              <EmailComponentWrapper authorization={authorization} />
            </section>
          </BoundedContent>
        </ErrorBoundary>
      )}
    </Box>
  )
})
